"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M20 10V7c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33l.51 1.53c.1.28.36.47.66.47s.56-.19.66-.47L5.67 17h12.67l.51 1.53c.09.28.35.47.65.47s.56-.19.66-.47l.51-1.53H22v-5c0-1.1-.9-2-2-2m-9 0H6V8c0-.55.45-1 1-1h4zm7 0h-5V7h4c.55 0 1 .45 1 1z"
}), 'KingBedRounded');